import React, {Component} from 'react';
import {HEADER_HEIGHT} from "../../../constants";
import MyTable from "../component/MyTable";
import moment from "moment";
import {Modal, message, Button, Tooltip, Popconfirm} from "antd";
import {Scrollbars} from "react-custom-scrollbars";
import MediaList from "../../newsContribute/component/modal/mediaList";
import BaseComponent from "../../../base/BaseComponent";
import {showStoryUrlConfig} from "../manuscriptsSubmitted/showStoryUrl-config";

class RecycleBin extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            mediaCode: '',
            params: {
                mediaId: '',
                keywords: '',
                page: 1,
                size: 10,
            },
            dataSource: [],
            total: 0,// 数据总条数
            treeData: [],
            storyId: 0,
            mediaListModalVisible : false,
            mediaListData: [],
            publishMediaListModalVisible: false,
            publishMediaListData: [],
        }
    }

    componentDidMount() {
        this.getDropdownDate();
        this.loadDataSource(this.state.params);
    }

    loadDataSource = (params={})=>{
        this.request({
            url: "/cm-sites-pms/story/recycle",
            body: {...params},
            callBack: (res) => {
                let count = 0;
                let data = [];
                if (res) {
                    count = res.count;
                    data = res.data;
                }
                this.setState({
                    total: count,
                    dataSource: data,
                })
            }
        });
    };

    // 表头
    getColumns = () => {
        return (
            [
                {
                    title: '标题',
                    dataIndex: 'title',
                    key: 'title',
                    width: 350,
                    render: (text, record) => {
                        let title = text;
                        if (!title && record.variableFields && record.variableFields['title']) {
                            title = record.variableFields['title'];
                        }
                        let id = record.id;
                        let mediaCode = record.mainMedia && record.mainMedia.mediaTypeCode || "";
                        return (
                            <div className={'titleContent'}>
                                {/*点击跳转*/}
                                <Tooltip placement={"topLeft"} title={title}><div style={{
                                    width: 250,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                }} onClick={() => {
                                    if (id && mediaCode) {
                                        this.state.mediaCode = mediaCode;
                                        this.jumpEditor({mediaCode, id})
                                    } else {
                                        message.error("稿件id丢失或稿件媒体丢失")
                                    }
                                }}>{title}</div></Tooltip>
                                {/*点击弹窗*/}
                                {record.child ?
                                    <div className={'son'} onClick={() => {
                                        this.setState({
                                            visible: true
                                        })
                                    }
                                    }>子</div>
                                    : null}
                            </div>
                        )
                    },
                },
                {
                    title: '媒体',
                    dataIndex: 'contributeMedia',
                    key: 'contributeMedia',
                    width: 280,
                    render: (text, record) => {
                        let mediaName = text&&text.length?text[0]:'';
                        let media=(<div style={{display:'flex'}}>
                            <span className={"text-pointer"} style={{maxWidth:100}}><Tooltip title={!text?"":text.join("，")}>{mediaName}</Tooltip></span>
                            {
                                text&&text.length>1?<div style={{padding:"0 5px"}}>等<span
                                    onClick={()=>{
                                        if(record.mediaIds && record.mediaIds.length > 1){
                                            this.getContributeTargetList(record.mediaIds.join(","), (data)=>{
                                                let convertData = ()=>{
                                                    let result = [];
                                                    for(let i = 0; data && i < data.length; i++){
                                                        let item = data[i];
                                                        result[i] = {icon: item.logoUrl, type:item.mediaTypeName, data: item.mediaList?item.mediaList.map(media=>{return {name:media.name}}):[]};
                                                    }
                                                    return result;
                                                };
                                                let mediaListData = convertData();
                                                this.setState({mediaListModalVisible:true, mediaListData});
                                            });
                                        }
                                    }}
                                    style={{color:"red",padding:"0 5px",cursor:"pointer"}}>{text.length}</span>个媒体</div>:null
                            }
                        </div>);
                        let oIcon = record.mediaLogo?<img src={record.mediaLogo} className={'oIcon'}/>:null;
                        return (
                            <div className={'media'}>
                                {oIcon}
                                {media}
                            </div>
                        )
                    }
                },
                {
                    title: '创建人',
                    dataIndex: 'submitterName',
                    key: 'submitterName',
                    width: 120,
                    render:(text,record)=>{
                        return(
                            <div title={record.submitterName} style={{width:"120px",overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis"}}>
                                {record.submitterName}
                            </div>
                        )
                    }
                },
                {
                    title: '移除时间',
                    dataIndex: 'operateTime',
                    key: 'operateTime',
                    width: 180,
                    render: (text, record) => {
                        let operateTime = record.operateTime ? moment(record.operateTime).format('YYYY-MM-DD HH:mm:ss') : null;
                        return (
                            <div>
                                {operateTime}
                            </div>
                        )
                    }
                },
                {
                    title: '操作',
                    key: 'action',
                    dataIndex: 'action',
                    width: 250,
                    render: (text, record) => {
                        return (
                            <div className={'a'}>
                                <Popconfirm title="确定要恢复吗？" okText="确定" cancelText="取消" onConfirm={()=>{
                                    this.restore(record.id)
                                }}>
                                    <Button size={'small'} type={'link'} style={{marginLeft: -8}}>恢复</Button>
                                </Popconfirm>
                                <Popconfirm title="确定要彻底删除吗？" okText="确定" cancelText="取消" onConfirm={()=>{
                                    this.realDelete(record.id)
                                }}>
                                    <Button size={'small'} type={'link'}>彻底删除</Button>
                                </Popconfirm>
                            </div>
                        )
                    },
                },
            ]
        )
    };

    // 点标题跳转编辑器
    jumpEditor = ({mediaCode, id}) => {
        window.openEditById({configName:"materialCenterStoryEditor", id, params:{
                activitiConfName:"activitiTreeRoot-xlc-sczxsglc",
                hideBtn:true
            }});
        return;
        // 根据storyId获取网站文章内容
        let that = this;
        let config = showStoryUrlConfig[mediaCode] || {};
        let parseOpenModule = (openModule)=>{
            let result = {};
            for(let attr in openModule){
                let attrValue = openModule[attr];

                if((typeof attrValue === "string") && /\${.*}$/.test(attrValue)){
                    let expression = attrValue.replace(/\${(.*)}$/,"$1");
                    let valueExeResult = eval(expression);
                    result[attr] = valueExeResult;
                }else{
                    result[attr] = attrValue;
                }
            }
            return result;
        };
        if(config.style === "noAjax"){
            if(!config.openModule){
                message.error(`showStoryUrlConfig[${mediaCode}].openModule配置不不存在`);
            }else{
                let result = parseOpenModule(config.openModule);
                that.state.editorWindow = window.openEditById({...result, hideBtn:true});
            }
            return;
        }

        let urls = config['urls'] || {};
        let url = urls['titleUrl'];
        let idKey = config['idKey'];
        let configName = config['module'];
        if (!(id && id.length > 1 && url && idKey && configName)) {
            return;
        }
        that.state.operateType = "contribute";
        that.state.storyId = id;
        this.request({
            url,
            body: {[idKey]: id},
            callBack: function (res) {
                let webStory = {};
                let id = 0;
                if (res) {
                    webStory = res;
                    id = res.id || 0;
                }
                that.state.webStory = webStory;

                let operateType = that.state.operateType;
                let storyId = that.state.storyId;
                //获取投稿流程的code
                let activitiConfName = that.sysConfigGetValueByKey("editor.activiti.conf.name.wzlc", "activitiTreeRoot-xlc-wzlc");
                that.state.editorWindow = window.openEditById({configName, id, params:{
                        activitiConfName,
                        webStory,
                        operateType,
                        storyId, hideBtn:true
                    }});
            },
            errorCallBack: function (res) {
                message.error('稿件加载失败！');
            }
        });
    };

    render() {
        let {total, dataSource, params, treeData} = this.state;
        let props = {
            onChange: (type, e)=>{this.onChange(type, e)},
            dataSource: dataSource, //表格数据
            total: total,
            columns: this.getColumns(),  //表格表头
            tabChange: ()=>{},
            params: params,
            tableWidth: window.innerWidth - 550 - 64,
            tableHeight: window.innerHeight - HEADER_HEIGHT - 57 - 20 - 81 - 15 - 15,
            width: window.innerWidth - 550,
            treeData: treeData
        };
        return (
            <div>
                <MyTable
                    {...props}
                ></MyTable>
                {/*查看提交媒体弹框*/}
                {this.renderSubmitMediaModal()}
            </div>
        );
    }

    //搜索功能
    onChange = (type, e) => {
        let {params} = this.state;
        switch (type) {
            case 'onChange':
                params['keywords'] = e.target.value;
                return this.setState({});
            case 'onSearch':
                params['keywords'] = e;
                break;
            case 'onSelect':
                params['mediaId'] = e;
                break;
            case 'page':
                params['page'] = e;
                break;
            case 'size':
                params['size'] = e;
                params['page'] = 1;
                break;
        }
        this.loadDataSource(this.state.params);
    };

    //下拉框数据
    getDropdownDate = () => {
        this.request({
            url: '/cm-sites-pms/media/getCurrentUserMediaGroupByType',
            // url: '/cm-sites-pms/media/getMediaGroupByType',
            callBack: (res) => {
                // console.log(res)
                let treeData = [];
                if (res) {
                    treeData = res;
                }
                // 过滤禁用的媒体
                let newData = treeData && treeData.map(item=>({
                    ...item,
                    mediaList: item.mediaList && item.mediaList.filter(media=>{
                        return  media.disable == 0;
                    })
                }));
                // 素材中心这里只保留网站和微信稿件
                if(newData){
                    let mediaTypes = this.sysConfigGetValueByKey("shiqu.media.type", "webNews,material").split(",");
                    newData = newData.filter(item=>{
                        return mediaTypes.indexOf(item.mediaTypeCode) > -1;
                    });
                }

                this.setState({
                    treeData: newData,
                })
            },
            errorCallBack: (e) => {
            },
        })
    };

    getContributeTargetList = (ids, callBack)=>{
        this.request({
            url : "/cm-sites-pms/media/getMediaGroupByIds",
            body: {ids}, callBack
        })
    };

    realDelete = (storyId)=>{
        // "/cm-sites-pms/story/delete" 这个是真删，下面是在素材中心删
        let url = "/cm-sites-pms/story/removeShow";
        this.request({
            url,
            method : "post",
            body: {storyId},
            callBack:()=>{
                this.loadDataSource();
            }
        });
    };

    restore = (storyId)=>{
        this.request({
            url : "/cm-sites-pms/story/restore",
            method : "post",
            body: {storyId},
            callBack:()=>{
                this.loadDataSource();
            }
        });
    };

    renderSubmitMediaModal = ()=>{
        return (
            <Modal
                title={"提交媒体"}
                footer={null}
                visible={this.state.mediaListModalVisible}
                onOk={()=>{this.setState({mediaListModalVisible:false})}}
                onCancel={()=>{this.setState({mediaListModalVisible:false})}}
                maskClosable={false}
            >
                <Scrollbars
                    autoHeight={true}
                    autoHeightMax={500}
                    autoHide={true}
                >
                    <MediaList group={this.state.mediaListData} />
                </Scrollbars>
            </Modal>
        );
    };
}

export default RecycleBin;